module.exports = __webpack_public_path__ + "static/media/icon_market_alert.dee6683d.png";